export enum NoteType {
    Undefined,
    Editors = 1,
    Source = 2,
    Authority = 3,
    Footnote = 4,
    Agency = 5
  }